// extracted by mini-css-extract-plugin
export default {"container":"connect-with-us_container__I3hfd","title":"connect-with-us_title__P70ql","iconContainer":"connect-with-us_iconContainer__O4Dq9"};